import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InsuranceHolder as InsuranceHolderType } from '@customTypes/ContactFormFields'
import { selectedInsuranceHolderContact, selectedInsuranceHolderPatient } from 'src/services/analytics'
import FormError from '@components/FormError'
import RadioButton from '@components/RadioButton'
import RadioGroup from '@components/RadioGroup'

const InsuranceHolder: React.FC = () => {
  const { t } = useTranslation()

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext()

  useEffect(() => {
    const watchSubscription = watch((values) => {
      if (values['insurance_holder'] === InsuranceHolderType.Contact) selectedInsuranceHolderContact()
      if (values['insurance_holder'] === InsuranceHolderType.Patient) selectedInsuranceHolderPatient()
    })

    return () => {
      watchSubscription.unsubscribe()
    }
  }, [watch])

  const isPatientChild = watch('patient_child')

  return (
    <RadioGroup isVertical>
      <RadioButton
        id={InsuranceHolderType.Contact}
        label={t('insurance_holder_contact')}
        {...register('insurance_holder')}
      />
      <RadioButton
        id={InsuranceHolderType.Patient}
        label={t('insurance_holder_patient')}
        disabled={isPatientChild}
        {...register('insurance_holder')}
      />
      {errors.insurance_holder && <FormError message={errors.insurance_holder.message} />}
    </RadioGroup>
  )
}

export default InsuranceHolder
